import { render, staticRenderFns } from "./stageWarn_page.vue?vue&type=template&id=4b374cd6&scoped=true"
import script from "./stageWarn_page.vue?vue&type=script&lang=js"
export * from "./stageWarn_page.vue?vue&type=script&lang=js"
import style0 from "./stageWarn_page.vue?vue&type=style&index=0&id=4b374cd6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b374cd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b374cd6')) {
      api.createRecord('4b374cd6', component.options)
    } else {
      api.reload('4b374cd6', component.options)
    }
    module.hot.accept("./stageWarn_page.vue?vue&type=template&id=4b374cd6&scoped=true", function () {
      api.rerender('4b374cd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/knowledge/stageWarn_page.vue"
export default component.exports